import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';

export enum ViewLoaderEnum {
    None = 'none',
    Circle = 'circle',
    Bar = 'bar'
}

export const defaultStudioViewLoader: ViewLoaderEnum = ViewLoaderEnum.Circle;
export const defaultViewerViewLoader: ViewLoaderEnum = ViewLoaderEnum.Bar;
export const defaultViewLoader: ViewLoaderEnum = environment.application === EnvironmentApplication.Viewer
    ? defaultViewerViewLoader
    : defaultStudioViewLoader;
